<section>
  <app-banner-image bannerClasses="bg-white" bannerImageUrl="" [bannerOpacity]="0">
    <div class="app-main flex-column flex-row-fluid align-items-center">
      <div class="banner-content fw-bold text-dark positon-relative py-16">
        <div #header class="d-flex flex-column justify-content-center fw-bold mb-12">
          <p class="fs-2hx mb-0 text-center">
            {{ "LANDING_PAGE.OUR_COURSE" | translate }}
          </p>
        </div>

        <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-6 justify-content-center">
          @if(isLoading()){
          <ng-container *ngTemplateOutlet="skeleton"></ng-container>
          <ng-container *ngTemplateOutlet="skeleton"></ng-container>
          <ng-container *ngTemplateOutlet="skeleton"></ng-container>

          <!-- <status-loading></status-loading> -->
          }@else { @for(recommend_course of courses; track $index; let i =
          $index ){
          @if(recommend_course.id && i+1 <= 4){ <app-course-recommend-item class="course-grid__item hover-elevate-up"
            [data]="recommend_course" [routerLink]="`/courses/${recommend_course.id}`"></app-course-recommend-item>
            }
            <!-- `min-w-300px` fought the row-cols it sits in: four 300px cards
               plus gaps overflow this container, so the fourth wrapped and the
               row read as three cards and a leftover. The grid already sizes
               them per breakpoint. -->

            } }
        </div>
        <!-- <span class="text-primary">{{ "APP.APP_NAME" | translate }}</span> -->
        <!-- <div class="fs-3x">
          {{ "LANDING_PAGE.ONLINE_COURSE" | translate }}
        </div> -->
      </div>
    </div>
  </app-banner-image>
</section>

<ng-template #skeleton>
  <div class="card min-h-500px w-300px px-0 mx-4">
    <div class="card-body d-flex flex-column">
      <div class="skeleton h-200px w-100"></div>
      <div class="skeleton h-40px w-100 mt-5 mb-2"></div>
      <div class="skeleton h-30px w-100 mt-2 mb-1"></div>
      <div class="separator mt-8 mb-4"></div>
      <div class="w-100 d-flex flex-column flex-center">
        <div class="skeleton h-25px w-40px mb-3"></div>
        <div class="skeleton h-30px w-100px"></div>
        <!-- The "buy now" button is `rounded-pill` in the real card. -->
        <div class="skeleton rounded-pill h-50px w-100 mt-4"></div>
      </div>
    </div>
  </div>
</ng-template>